import {handleActions} from 'redux-actions'

export default function createReducer({
    REPORTS = {}
}) {
    const authorizationInfo = REPORTS.AUTHORIZATION_INFO ? REPORTS.AUTHORIZATION_INFO : {}

    const initialState = {
        allUsersTimeTrackAvailable: !!authorizationInfo.allUsersTimeTrackAvailable,
        overtimeAvailable: !!authorizationInfo.overtimeAvailable,
    }

    return handleActions({}, initialState)
}



// WEBPACK FOOTER //
// ./web/js/reports/authorizationInfo/reducer.js